import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import de from './locales/de.json';

const resources = {
  en: {
    translation: en,
  },
  de: {
    translation: de,
  },
};

i18n
  .use(LanguageDetector) // Detects user's browser language
  .use(initReactI18next) // Integrates with React
  .init({
    resources,
    fallbackLng: 'de', // Default to German when nothing was stored
    supportedLngs: ['en', 'de'], // Only allow English and German
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ['localStorage'], // Only an explicit switch counts, not the browser language
      caches: ['localStorage'], // Persist the switch for the next visit
    },
  });

export default i18n;
